import { Coordinates } from './Coordinates'

export interface Location {
  address: string;
  name: string;
  coords: Coordinates;
  type?: string;
}

export class LocationModel implements Location {
  address: string;
  coords: Coordinates;
  name: string;
  type: string;
  constructor(address: string, coords: Coordinates, type: string, name?: string) {
    this.address = address
    this.coords = { ...coords }
    this.type = type
    this.name = name || this.address.split(',')[0]
  }
}